import { ButtonHTMLAttributes, type HTMLAttributes } from 'react';
import { CalendarDay, DayPicker, Modifiers } from 'react-day-picker';
import { sv } from 'react-day-picker/locale';
import { twMerge } from 'tailwind-merge';
import { CalendarRangePickerProps } from '@my-pages/features/calendar/types';

const CalendarRangeDatePicker = ({ settings }: CalendarRangePickerProps) => {
    return (
        <>
            <DayPicker
                mode={'range'}
                locale={sv}
                showWeekNumber={true}
                showOutsideDays={true}
                {...settings}
                components={{
                    Day: (
                        props: {
                            /** The day to render. */
                            day: CalendarDay;
                            /** The modifiers to apply to the day. */
                            modifiers: Modifiers;
                        } & HTMLAttributes<HTMLDivElement>,
                    ) => {
                        const { day, modifiers, className, ...elementProps } = props;
                        const filteredClassName = className?.replaceAll('rdp-disabled', '');
                        const newClassName = twMerge('rdp-day', filteredClassName, modifiers.available ? 'rdp-day--available' : 'rdp-day--disabled');
                        return (
                            <td
                                {...elementProps}
                                className={newClassName}
                            >
                                {props.children}
                            </td>
                        );
                    },
                    DayButton: (
                        props: {
                            day: CalendarDay;
                            modifiers: Modifiers;
                        } & ButtonHTMLAttributes<HTMLButtonElement>,
                    ) => {
                        const { day, modifiers, className, ...buttonProps } = props;
                        buttonProps.disabled = !modifiers.available;
                        const newClassName = modifiers.available ? twMerge('rdp-day_button--available', className) : twMerge('rdp-day_button--disabled', className);
                        return (
                            <>
                                <button
                                    {...buttonProps}
                                    className={newClassName}
                                >
                                    {props.children}
                                </button>
                            </>
                        );
                    },
                }}
            />
        </>
    );
};

export default CalendarRangeDatePicker;
